export enum TransportType {
  BUS = 'Bus',
  TRAIN = 'Train',
}
